import { render, staticRenderFns } from "./logairlift.vue?vue&type=template&id=b96e3bae&scoped=true&"
import script from "./logairlift.vue?vue&type=script&lang=js&"
export * from "./logairlift.vue?vue&type=script&lang=js&"
import style0 from "./logairlift.vue?vue&type=style&index=0&id=b96e3bae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96e3bae",
  null
  
)

export default component.exports